<template>
  <div>
    <template v-if="!IsDetail">
      <el-row style="margin-bottom:10px;">
        <el-col :span="4">
          <el-upload
            :headers="header"
            :action="uploadUrl"
            :on-progress="uploadProcess"
            :on-success="handleSuccess"
            :accept="accept"
            :before-upload="beforeUpload"
            :data="data"
            :show-file-list="false"
          >
            <el-button type="primary" size="mini">添加</el-button>
          </el-upload>
        </el-col>
        <el-col :span="20">
          <el-progress v-show="showProgress" style="margin-top:6px;" :percentage="uploadPercent" />
        </el-col>
      </el-row>
      <span v-if="showTip" style="font-size: 12px;color: #909399;">{{tip}}</span>
    </template>
  </div>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    tip: {
      type: String,
      default:
        "支持上传的文件格式：jpg、png、doc、docx、xls、xlsx、ppt、pptx、pdf、txt、bmp",
    },
    showTip: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: '.jpg,.png,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.bmp'
    },
    data: {
      type: Object,
      default: () => {},
    },
    uploadUrl: {
      type: String,
      default: "/api" + api.uploadPictureUrl,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    //文件大小，默认50Mb
    fileSize: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      isLoading: false,

      showProgress: false, //显示进度条
      uploadPercent: 0, //进度条的进度
    };
  },
  computed: {
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    //上传前回调
    beforeUpload(file) {
      console.log("beforeUpload", file);
      // return false;
      var fileSize = file.size / 1024 / 1024 < this.fileSize;
      if (
        [
          "image/jpeg",
          "image/png",
          "application/msword", //doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //docx
          "application/vnd.ms-excel", //xls
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
          "application/vnd.ms-powerpoint", //ppt
          "application/vnd.openxmlformats-officedocument.presentationml.presentation", //pptx
          "application/pdf", //pdf
          "text/plain", //txt
          "image/bmp",
        ].indexOf(file.type) == -1
      ) {
        this.$message.warning("请上传正确的文件格式");
        return false;
      }

      // if (!fileSize) {
      //   this.$message.warning(`文件大小不能超过${this.fileSize}Mb`);
      //   return false;
      // }
      this.showProgress = true;
    },
    //进度条
    uploadProcess(event, file, fileList) {
      this.uploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleSuccess(res, file) {
      console.log("上传成功", res, file);
      this.$emit("input", res.Data);
      this.$emit("success", file);

      this.showProgress = false;
      this.uploadPercent = 0;

      if (res.Code != 0) {
        this.$message.warning(res.Message);
      }
    },
  },
};
</script>